






















import swiper, { Navigation, Autoplay, SwiperOptions } from 'swiper';
import { directive } from 'vue-awesome-swiper';
import { Component, Prop, Vue } from 'vue-property-decorator';
import 'swiper/swiper-bundle.css';
import { SlideItem } from '@/const';

swiper.use([Navigation, Autoplay]);

@Component({
  directives: {
    swiper: directive,
  },
})
export default class WebCustomerSwiper extends Vue {
  @Prop() private slides!: SlideItem[];

  swiperOption: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    navigation: {
      nextEl: '.custom-nav-next',
      prevEl: '.custom-nav-prev',
    },
  };
}
